import { Chart } from 'chart.js';

const maandLabels = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
const isDark = () => document.documentElement.classList.contains('dark');
const txtColor = () => isDark() ? '#9ca3af' : '#6b7280';
const gridColor = () => isDark() ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';

export function typeDistChart(cfg) {
    return {
        _pie: null, _bar: null,
        init() {
            this.$nextTick(() => this._render());
        },
        destroy() {
            this._pie?.destroy();
            this._bar?.destroy();
        },
        _render() {
            const pieCanvas = this.$refs.pieChart;
            const barCanvas = this.$refs.barChart;
            if (!pieCanvas || !barCanvas) return;
            this._pie = new Chart(pieCanvas, {
                type: 'doughnut',
                data: { labels: cfg.labels, datasets: [{ data: cfg.data, backgroundColor: cfg.colors, borderWidth: 0 }] },
                options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'right', labels: { color: txtColor(), font: { size: 11 } } } } }
            });
            this._bar = new Chart(barCanvas, {
                type: 'bar',
                data: { labels: cfg.labels, datasets: [{ data: cfg.data, backgroundColor: cfg.colors }] },
                options: {
                    responsive: true, maintainAspectRatio: false, indexAxis: 'y',
                    plugins: { legend: { display: false } },
                    scales: { x: { ticks: { color: txtColor() }, grid: { color: gridColor() } }, y: { ticks: { color: txtColor(), font: { size: 11 } }, grid: { display: false } } }
                }
            });
        }
    };
}

export function monthlyChart(key, data, color) {
    return {
        _chart: null,
        init() {
            this.$nextTick(() => {
                const canvas = this.$refs.chart;
                if (!canvas) return;
                this._chart = new Chart(canvas, {
                    type: 'bar',
                    data: { labels: maandLabels, datasets: [{ data: data, backgroundColor: color + '80', borderColor: color, borderWidth: 1 }] },
                    options: {
                        responsive: true, maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: { x: { ticks: { color: txtColor() }, grid: { display: false } }, y: { ticks: { color: txtColor() }, grid: { color: gridColor() }, beginAtZero: true } }
                    }
                });
            });
        }
    };
}

export function trendLine(key, data, color, unit) {
    return {
        _chart: null,
        init() {
            this.$nextTick(() => {
                const canvas = this.$refs.chart;
                if (!canvas) return;
                this._chart = new Chart(canvas, {
                    type: 'line',
                    data: {
                        labels: maandLabels,
                        datasets: [{
                            data: data, borderColor: color, backgroundColor: color + '18',
                            pointBackgroundColor: color, pointRadius: 4, pointHoverRadius: 6,
                            borderWidth: 2, fill: true, tension: 0.3,
                        }]
                    },
                    options: {
                        responsive: true, maintainAspectRatio: false,
                        plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => ctx.parsed.y + ' ' + unit } } },
                        scales: {
                            x: { ticks: { color: txtColor() }, grid: { display: false } },
                            y: { ticks: { color: txtColor(), callback: (v) => v + ' ' + unit }, grid: { color: gridColor() } }
                        }
                    }
                });
            });
        }
    };
}

export function raceDistChart(data) {
    return {
        _chart: null,
        init() {
            this.$nextTick(() => {
                const canvas = this.$refs.chart;
                if (!canvas) return;
                const labels = ['Podium (1-3)', 'Top-10 (4-10)', 'Top-30 (11-30)', 'Peloton (31-80)', 'Achteraan (81+)', 'DNF'];
                const colors = ['#d97706', '#059669', '#0ea5e9', '#6b7280', '#9ca3af', '#dc2626'];
                this._chart = new Chart(canvas, {
                    type: 'bar',
                    data: { labels: labels, datasets: [{ data: data, backgroundColor: colors }] },
                    options: {
                        responsive: true, maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: { x: { ticks: { color: txtColor(), font: { size: 10 } }, grid: { display: false } }, y: { ticks: { color: txtColor() }, grid: { color: gridColor() }, beginAtZero: true } }
                    }
                });
            });
        }
    };
}
